import { render, staticRenderFns } from "./SaasAccount.vue?vue&type=template&id=0770e00c&scoped=true"
import script from "./SaasAccount.vue?vue&type=script&lang=js"
export * from "./SaasAccount.vue?vue&type=script&lang=js"
import style0 from "./SaasAccount.vue?vue&type=style&index=0&id=0770e00c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0770e00c",
  null
  
)

export default component.exports